<template>
  <div class="home">
    <div class="header">
      <img
        src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/83a833cad3caf31aee667d64a35eceef.jpg~tplv-55ejei7tpt-image.image"
        alt=""
        class="icon-img"
        @click="goHomePage"
      >
    </div>
    <div class="content">
      <p class="title">巨量千川平台服务协议</p>
      <iframe class="content-frame" style="width: 100%; height: 100%" src="https://lf3-cdn-tos.draftstatic.com/obj/ies-hotsoon-draft/qianchuan/a96a6a25-17d8-4083-9529-0c79102aa0b9.html" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Service",
  methods: {
    goHomePage() {
      window.location.href = window.location.origin;
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  text-align: center;
  height: 100vh;
  display: flex;
  flex-flow: column;
  .header {
    height: 70px;
    z-index: 2;
    background: #fff;
    text-align: left;
    padding: 17px 32px;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e5e5;;
    .icon-img {
      width: 140px;
      height: 35px;
      cursor: pointer;
    }
  }
  .content {
    padding-top: 28px;
    width: 100%;
    margin: 0 auto;
    word-wrap: wrap;
    display: flex;
    flex-flow: column;
    flex: 1;
    .title {
      font-weight: 600;
      font-size: 28px;
      line-height: 42px;
      color: #333333;
      margin: 0;
      text-align: center;
    }
    .content-frame {
      flex: 1;
    }
  }
}
</style>
